














import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";
import { SwiperModel } from "../models/swiper.model";

@Component({
  name: "AppSlide"
})
export default class extends Vue {
  @Prop({ required: true }) slide!: SwiperModel;
}
